import { Typography } from '@material-ui/core'

type Props = {
  children: string
}

export default function PageTitle({ children }: Props): JSX.Element {
  return <Typography variant="h3">{children}</Typography>
}
